import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

interface UploadOrgLogoResponse {
  data?: {
    branding: {
      logo_url: string;
    };
  };
  detail?: string;
}

interface UploadOrgLogoProps {
  file: File;
}

export const uploadOrgLogo = async ({
  file,
}: UploadOrgLogoProps): Promise<UploadOrgLogoResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const formData = new FormData();
  formData.append('file', file);

  const response = await apiRequest<UploadOrgLogoResponse>({
    url: `/organizations/${orgId}/upload_logo`,
    method: 'PUT',
    target: 'platform',
    formData: true,
    body: formData,
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to upload org logo',
    };
  }

  return response as UploadOrgLogoResponse;
};
